import { render, staticRenderFns } from "./PartitionMember.vue?vue&type=template&id=5a5b2af4&"
import script from "./PartitionMember.vue?vue&type=script&lang=js&"
export * from "./PartitionMember.vue?vue&type=script&lang=js&"
import style0 from "./PartitionMember.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports